module.exports = __webpack_public_path__ + "static/media/pie_bg.a3bc9d52.svg";